export const message = {
  language: '简体中文',
  home_nav: {
    nav_title_home: '首页',
    nav_title_one: '公司介绍',
    nav_title_two: '产品介绍',
    nav_title_three: '案例展示',
    nav_title_four: '解决方案',
    nav_title_five: '使用教程',
    nav_title_six: '联系我们',
    nav_title_seven: '下载',
  },
  advantage: {
    title: '我们的优势',
    type: '专业 | 实用 | 快速 | 低成本',
    info1: '由工厂经理，生产、物流、质量经理及精益生产专家主导开发的系统，融合精益生产理念和工具。',
    info2: '标准模块可以独立使用也可以组合使用，同时可以分批激活模块。适用于制造型工厂生产现场管理。',
    info3: '模块化开发，标准管理流程，无需改造设备，大幅缩短项目实施周期。云服务版最短1天。',
    info4: '提供多种解决方案，根据工厂规模和特点可选择云服务版或本地服务版，云服务版部署成本低廉。',

  },
  products: {
    title: '我们的产品',
    type: [{
      type: '停线求助'
    }, {
      type: '空转计时'
    }, {
      type: '设备异常'
    }, {
      type: '设备点检'
    }, {
      type: '备件申请'
    }, {
      type: '班末总结'
    }, {
      type: '不合格品'
    }, {
      type: '质量门'
    }, {
      type: '分层审核'
    }, {
      type: '4M变化点'
    }, {
      type: '模具问题'
    }, {
      type: '质量检验'
    }, {
      type: '7大浪费'
    }, {
      type: '客户质量'
    }, {
      type: '工位平衡'
    }, {
      type: '交接班'
    }, {
      type: '技能培训'
    }, {
      type: '人员培训'
    }, {
      type: '安全风险'
    }, {
      type: '5S改善'
    }, {
      type: '改善提案'
    }, {
      type: '公司公告'
    }, {
      type: '疫病防控'
    }]
  },
  example: {
    title: '我们的案例'
  },
  solution: {
    head: '针对制造行业',
    head1: '致力于提升工场现场管理信息化,融合精益生产的理念和工具',
    head2: '为工场提供实用的生产管理智能化解决方案',
    info: [{
      title: "本地化服务",
      desc: "针对数据安全要求较高的客户，在公司内部服务器构建玩转工厂APP使用环境，运营数据保存在客户本地，满足客户对数据安全的最高要求。",
      desc1: "安全的在工厂内部网络中使用（Andon、故障报修、安全风险、维护保养、物料管理等）",
      desc2: "可以满足大部分工场生产管理的基本需求低成本、启动快",

    }, {
      title: "云服务",
      desc: "使用“阿里云”服务器进行架构，在公网环境下可以无限制使用玩转工厂，运营数据保存在我司服务器中，我司会对数据进行安全加固，用以满足客户对数据安全的需求；可以满足大部分工场生产管理的基本需求低成本、启动快",
      desc1: "使用客户指定的云服务提供商（如：亚马逊云、微软云、腾讯云、华为云等等），在公网环境下可以无限制使用玩转工厂，运营数据保存在我司服务器中，我司会对数据进行安全加固，用以满足客户对数据安全的需求；可以满足大部分工场生产管理的基本需求低成本、启动快",

    }, {
      title: "定制服务",
      desc: "满足客户的个性化需求，深度定制。可基于客户已有的管理流程、软件系统、终端硬件，也可使用新的硬件，再结合玩转工厂APP的移动属性，开发出属于自己的更加智能和高效的管理系统，针对有自定义需要的用户，根据客户实际生成环境进行定制化开发，最大化满足工厂各方面的自定义需求；高成本、高度适配工厂实际生成环境，满足特殊需求",

    }],
  },
  case: {
    head: '多工厂实施案例',
    head1: '致力于提升工场现场管理信息化,融合精益生产的理念和工具',
    head2: '为工场提供实用的生产管理智能化解决方案',
  },
  caseMenu: {
    title: '案例一 |案例二 |案例三 |案例四 |'
  },
  caseInfoList: [{
    index: 0,
    infoDesc: "汽车企业为了解决停车供需不平衡不充分以及人们普遍反映的泊车入库难找车难导致的停车矛盾，需要引入自动驾驶系统，该项目也是对城市服务智能化升级和新型商业模式的探索",
    infoSrc: "solution_hardware.png",
    solutionDesc: "汽车企业为了解决停车供需不平衡不充分以及人们普遍反映的泊车入库难找车难导致的停车矛盾，需要引入自动驾驶系统，该项目也是对城市服务智能化升级和新型商业模式的探索",
    solutionSrc: "solution_hardware.png",
    advantageDesc: "汽车企业为了解决停车供需不平衡不充分以及人们普遍反映的泊车入库难找车难导致的停车矛盾，需要引入自动驾驶系统，该项目也是对城市服务智能化升级和新型商业模式的探索",
    advantageSrc: "solution_hardware.png",
    valueDesc: "汽车企业为了解决停车供需不平衡不充分以及人们普遍反映的泊车入库难找车难导致的停车矛盾，需要引入自动驾驶系统，该项目也是对城市服务智能化升级和新型商业模式的探索",
    valueSrc: "solution_hardware.png",

  }, {
    index: 1,
    infoDesc: "案例2详细介绍",
    infoSrc: "solution_hardware.png",
    solutionDesc: "汽车企业为了解决停车供需不平衡不充分以及人们普遍反映的泊车入库难找车难导致的停车矛盾，需要引入自动驾驶系统，该项目也是对城市服务智能化升级和新型商业模式的探索",
    solutionSrc: "solution_hardware.png",
    advantageDesc: "汽车企业为了解决停车供需不平衡不充分以及人们普遍反映的泊车入库难找车难导致的停车矛盾，需要引入自动驾驶系统，该项目也是对城市服务智能化升级和新型商业模式的探索",
    advantageSrc: "solution_hardware.png",
    valueDesc: "汽车企业为了解决停车供需不平衡不充分以及人们普遍反映的泊车入库难找车难导致的停车矛盾，需要引入自动驾驶系统，该项目也是对城市服务智能化升级和新型商业模式的探索",
    valueSrc: "solution_hardware.png",

  }, ],
  video: {
    head: '零成本学习如何更快捷、效率的管理工场',
    info: [{
      title: 'APP教学视频 ',
      desc: '您可以点击下面的视频，查看并学习“玩转工厂”的,使用方法里面涵盖了APP的功能，以及基本操作方式，让您快速掌握我们的APP ',
      source1: 'http://www.w3school.com.cn/i/movie.ogg',
      source2: 'http://www.w3school.com.cn/i/movie.mp4',
    }, {
      title: 'WEB教学视频',
      desc: '您可以点击下面的视频，查看并学习“玩转工厂”的,使用方法里面涵盖了WEB的功能，以及基本操作方式，让您快速掌握我们的WEB',
      source1: 'http://www.baoxiniao.com.cn/video/oceans-clip.mp4',
      source2: 'http://www.baoxiniao.com.cn/video/oceans-clip.mp4',
    }],

  },
  contact: {
    head: "为您提供优质的服务与技术支持",
    head2: "提供邮件、电话、微信、微信公众号咨询",
  },

}



// WEBPACK FOOTER //
// ./src/assets/language/home/Zh-cn.js